import { azureAppInstaller } from "./azure-app";
import { azureBastionHostInstaller } from "./bastion-host";
import { azureIamAssessmentInstaller } from "./iam-assessment";
import { azureIamWriteInstaller } from "./iam-write";
import { AzureInstaller } from "./types";

export const azureInstaller: AzureInstaller = {
  root: {
    items: {},
  },
  "iam-write": azureIamWriteInstaller,
  "iam-assessment": azureIamAssessmentInstaller,
  "azure-app": azureAppInstaller,
  "bastion-host": azureBastionHostInstaller,
};
